import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SettingsState {
  // Playback settings
  skipDownvoted: boolean

  // Actions
  setSkipDownvoted: (value: boolean) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      skipDownvoted: false,

      setSkipDownvoted: (value) => set({ skipDownvoted: value }),
    }),
    {
      name: 's3nd-settings',
    }
  )
)
